import { Button, Grid, Typography } from '@mui/material';
import { find, range } from 'lodash-es';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AssignProductCell from './AssignProductCell';
import { actions } from '../../store/dux/product-placement-vpi-dux';

export default function AssignProductRow(props) {
  const { crop, field, productAssignments } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (productAssignments.length === 0) {
      dispatch(actions.addProduct(field.aaManagedId, 0));
    }
  }, [dispatch, field.aaManagedId, productAssignments.length]);

  function addProduct(aaid, sortOrder) {
    dispatch(actions.addProduct(aaid, sortOrder));
  }

  function getComponent(sortOrder) {
    const productAssignment = find(productAssignments, { sortOrder });

    if (productAssignment) {
      return getAssignmentCell(sortOrder, productAssignment);
    }

    return getAddButton(sortOrder);
  }

  function getAssignmentCell(index, productAssignment) {
    return (
      <AssignProductCell
        field={field}
        crop={crop}
        sortOrder={index}
        key={`assignment-cell-${index}`}
        assignment={productAssignment}
      />
    );
  }

  function getAddButton(index) {
    return (
      <Button
        onClick={() => addProduct(field.aaManagedId, index)}
        data-testid={`add-product-${field.aaManagedId}-${index}`}
      >
        <AddCircleIcon color={'primary'} />
      </Button>
    );
  }

  return (
    <>
      <Grid xs={3} item sx={{ pl: 1 }}>
        <Typography>{field.fieldName}</Typography>
      </Grid>
      {range(0, 3).map((index) => (
        <Grid xs={3} item key={`assignment-row-${index}`}>
          {getComponent(index)}
        </Grid>
      ))}
    </>
  );
}
